import Box from "@mui/material/Box";
import { Button, OutlinedInput, TextField } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import React, { useEffect, useState } from "react";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";

import styles from "./styles.module.scss";
import { toast } from "react-toastify";
import { IUserTableHeadCell } from "../../../types/user/userTable";
import { Delete, Edit } from "@mui/icons-material";
import { logger } from "../../../utils/logger";
import diseaseService from "../../../services/disease";
import SaveButton from "../../common/Button";
import { IDisease } from "./Treatment";
import { useAppDispatch } from "../../../redux/store";
import { setLoadingAction } from "../../../redux/utils/actions";

const headCells: readonly IUserTableHeadCell[] = [
  {
    id: "treatmentName",
    numeric: false,
    label: "Treatment Name",
  },
  {
    id: "action",
    numeric: true,
    label: "Action",
  },
];

export default function TreatmentListTable({
  gridData,
  setGridData,
  getData,
}: {
  gridData: IDisease[];
  setGridData: React.Dispatch<React.SetStateAction<IDisease[]>>;
  getData: () => Promise<void>;
}) {
  const [pageNo, setPageNo] = useState(0);
  const [pageSize] = useState(10);

  const dispatch = useAppDispatch();

  const updateDisease = async (index: number) => {
    try {
      dispatch(setLoadingAction(true));
      await diseaseService.update(gridData[index]._id, {
        name: gridData[index].name,
      });
      getData();
      dispatch(setLoadingAction(false));
    } catch (e) {
      dispatch(setLoadingAction(false));
      logger.error(e);
    }
  };

  const deleteDisease = async (index: number) => {
    try {
      dispatch(setLoadingAction(true));
      await diseaseService.deleteDisease(gridData[index]._id);
      getData();
      dispatch(setLoadingAction(false));
    } catch (e) {
      dispatch(setLoadingAction(false));
      logger.error(e);
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper sx={{ width: "100%", mb: 2 }}>
        <TableContainer>
          <Table
            sx={{ minWidth: 750 }}
            aria-labelledby="tableTitle"
            size="medium"
          >
            <TableHead>
              <TableRow>
                {headCells.map((headCell, i) => (
                  <TableCell
                    key={i}
                    align={headCell.id === "action" ? "right" : "left"}
                    className={styles.thead}
                  >
                    <b className={styles.tableHead}>{headCell.label}</b>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {gridData?.map((data, i) => (
                <TableRow key={`treatment-${i}`}>
                  <TableCell
                    className={styles.tableDefine}
                    component="th"
                    scope="row"
                  >
                    {data.isEditOpened ? (
                      <Box sx={{ display: "flex", gap: "20px" }}>
                        <OutlinedInput
                          id="outlined-adornment-weight"
                          name="searchField"
                          value={data.name}
                          onChange={(e) => {
                            const _data = [...gridData];
                            _data[i].name = e.target.value;
                            setGridData(_data);
                          }}
                          aria-describedby="outlined-weight-helper-text"
                          inputProps={{
                            "aria-label": "weight",
                          }}
                          className={styles.inputField}
                        />
                        <SaveButton
                          color="alert"
                          type="button"
                          onClick={() => updateDisease(i)}
                        >
                          Save
                        </SaveButton>
                      </Box>
                    ) : (
                      <span style={{ color: "#da3923" }}>{data.name}</span>
                    )}
                  </TableCell>
                  <TableCell className={styles.tableDefine} align="left">
                    <Box className={styles.actionSx}>
                      <Button
                        sx={{ minWidth: "auto", p: 0 }}
                        type="button"
                        className={styles.btnLink}
                        // onClick={() => navigateToUserEdit(item._id)}
                      >
                        <Edit
                          sx={{ color: "#606164" }}
                          onClick={() => {
                            const _data = [...gridData];
                            _data[i].isEditOpened = true;
                            setGridData(_data);
                          }}
                        />
                      </Button>
                      <Button
                        sx={{ minWidth: "auto", p: 0 }}
                        type="button"
                        className={styles.btnLink}
                        onClick={() => deleteDisease(i)}
                      >
                        <Delete sx={{ color: "#606164" }} />
                      </Button>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {/* <Paper elevation={0} className={styles.patientTableBtnStyle}>
          <Button
            type="button"
            className={styles.buttonStyle}
            onClick={getPrevPage}
            disabled={pageNo === 0}
          >
            Previous
          </Button>
          <span>
            {pageNo * pageSize + 1}-{pageNo * pageSize + gridData?.data?.length}{" "}
            of {gridData?.result}
          </span>
          <Button
            type="button"
            disabled={(pageNo + 1) * pageSize > gridData?.result}
            className={styles.buttonStyle}
            onClick={getNextPage}
          >
            Next
          </Button>
        </Paper> */}
      </Paper>
      {/* {open && <PatientDialog open={open} setOpen={setOpen} />} */}
    </Box>
  );
}
